import { FormattedMessage } from 'react-intl';

export function ProductMostRecentUnavailable() {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center h-100 px-5 border border-top-0 text-danger">
      <div className="icon">highlight_off</div>
      <p className="text-center">
        <FormattedMessage id="productSelector.tab.mostRecent.error" />
      </p>
    </div>
  );
}
